
import offer from "@/apollo/queries/offer/offer";
import conditionPhone from "@/mixins/conditionPhone";
import filters from "@/mixins/filters";
import jsonld from "@/mixins/jsonld";
import { mapActions, mapGetters, mapMutations } from "vuex";
// import { closingOfElementWithOpenChildElements } from 'parse5/lib/common/error-codes';

export default {
  mixins: [jsonld, filters, conditionPhone],
  props: {
    pageTitle: String,
    description: String,
    crumbs: Array
  },
  data() {
    return {
      jsonType: "car",
      showFixed: false,
      stateScroll: false
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    window.addEventListener("scroll", () => {
      if (window.scrollY >= 432) {
        this.stateScroll = true;
      } else {
        this.stateScroll = false;
      }
    });
    this.setBackButton(this.currentBackButton);
  },
  beforeDestroy() {
    this.setBackButton({});
  },
  async fetch() {
    if (Number(this.$route.params.car)) {
      let variables = {
        site_id: this.site_id,
        mark_slug: this.$route.params.mark,
        folder_slug: this.$route.params.model,
        dateFormat: "j F Y года.",
        external_id: Number(this.$route.params.car)
      };
      let response = await this.request({ query: offer, variables: variables });
      await this.setOffer(response.data.offer);
      await this.sendYandexCommercial();
      await this.sendVkTarget();
    }
  },
  computed: {
    ...mapGetters({
      // domain: 'domain',
      site_id: "site_id",
      offer: "catalog/catalog-cars/offer",
      carPageLoaded: "catalog/catalog-cars/carPageLoaded",
      benefitsCar: "benefits/benefitsCar",
      marks: "marks/marks/allMarks",
      folders: "folders/folders/folders"
      // focusShowFixed: 'car/car/focusShowFixed'
    }),
    currentBackButton() {
      let long =
        this.crumbs[2].title === "Mercedes-Benz" ||
        this.crumbs[2].title === "Land Rover";
      return {
        title:
          "Все " +
          (!long ? this.crumbs[2].title + " " : "") +
          this.crumbs[3].title,
        link: this.crumbs[3].link
      };
    }
  },
  beforeMount() {
    // window.addEventListener('scroll', this.handleScroll);
    // setTimeout(function () {
    // 	window.scrollTo(0, -100);
    // }, 1);
  },
  methods: {
    ...mapMutations({
      setOffer: "catalog/catalog-cars/SET_OFFER",
      setBackButton: "header/header/SET_BACK_BUTTON"
      // setIsOfferClick: 'filters/filters/SET_IS_OFFER_CLICK',
      // setComponentCatalog: 'filters/filters/SET_COMPONENT_CATALOG',
    }),
    ...mapActions({
      request: "filters/filters/request",
      openModal: "modal/modal-main/openModal"
    }),
    sendVkTarget() {
      if (process.client && this.offer) {
        _tmr.push({
          type: "reachGoal",
          id: this.settings.vktarget,
          value: this.offer.price,
          goal: "viewProduct",
          params: { product_id: this.offer.external_id }
        });
      }
    },
    sendYandexCommercial() {
      if (process.client && this.offer) {
        dataLayer.push({
          ecommerce: {
            detail: {
              products: [
                {
                  id: this.offer.external_id,
                  name: `${this.offer.mark.title} ${this.offer.folder.title}, ${this.offer.year} года, ${this.offer.gearbox.title}, ${this.offer.price} руб. - ${this.offer.external_id}`,
                  price: this.offer.price,
                  brand: this.offer.mark.title,
                  category: `С пробегом/${this.offer.mark.title}/${this.offer.folder.title}/${this.offer.name}`,
                  quantity: 1
                }
              ]
            }
          }
        });
      }
    },
    callback() {
      let payload = {
        modal_data: this.offer,
        modal_component: "modal-callback",
        modal_title: "Заявка на обратный звонок",
        modal_sub_title: this.offer.name
      };
      this.openModal(payload);
    },
    handleScroll() {
      this.showFixed =
        process.client && this.$device.isMobile && window.scrollY > 369;
    }
  }
};
